import { render, staticRenderFns } from "./AnomaliesAmount.vue?vue&type=template&id=575b7768&scoped=true&"
import script from "./AnomaliesAmount.vue?vue&type=script&lang=ts&"
export * from "./AnomaliesAmount.vue?vue&type=script&lang=ts&"
import style0 from "./AnomaliesAmount.vue?vue&type=style&index=0&id=575b7768&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575b7768",
  null
  
)

export default component.exports